import {
  createGoods,
  getGoodsList,
  upload,
  getGoodsDetail,
  getRecommendGoodsList,
  getAdList,
  shareSign
} from '../../api/order.js'
export default {
  // 发布商品
  handleCreateGoods({ commit }, params) {
    return new Promise((resolve, reject) => {
      createGoods(params).then(res => {
        resolve(res)
      }).catch(err => {
        reject(err)
      })
    })
  },
  // 上传图片
  handleUpload({ commit }, params) {
    return new Promise((resolve, reject) => {
      upload(params).then(res => {
        resolve(res)
      }).catch(err => {
        reject(err)
      })
    })
  },
  // 首页推荐
  handleRecommendGoodsList({ commit }, params) {
    return new Promise((resolve, reject) => {
      getRecommendGoodsList(params).then(res => {
        resolve(res)
      }).catch(err => {
        reject(err)
      })
    })
  },
  // 商品列表
  handleGoodsList({ commit }, params) {
    return new Promise((resolve, reject) => {
      getGoodsList(params).then(res => {
        resolve(res)
      }).catch(err => {
        reject(err)
      })
    })
  },
  // 广告列表
  handleAdList({ commit }, params) {
    return new Promise((resolve, reject) => {
      getAdList(params).then(res => {
        resolve(res)
      }).catch(err => {
        reject(err)
      })
    })
  },

  // 商品详情
  handleGoodsDetail({ commit }, params) {
    return new Promise((resolve, reject) => {
      getGoodsDetail(params).then(res => {
        resolve(res)
      }).catch(err => {
        reject(err)
      })
    })
  },
  //获取wx签名
  handleShareSign ({ commit }, params) {
    return new Promise((resolve, reject) => {
      shareSign(params).then(res => {
        resolve(res)
      }).catch(err => {
        reject(err)
      })
    })
  },
}
